import { render } from "./ResendCH.vue?vue&type=template&id=3923f021"
import script from "./ResendCH.vue?vue&type=script&lang=js"
export * from "./ResendCH.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__